import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import ImageResize from '@/utils/ImageResize'

export default {
  name: 'NoticeTestDeliveryModal',
  components: {
    Loading
  },
  data () {
    return {
      processing: false
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.noticeTestDeliveryModal.active,

      // form
      values: state => state.noticeForm.values,
      formValues: state => state.noticeTestDeliveryModal.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getValue: 'noticeForm/getValue',
    }),

    // input
    inpDeviceSerial: {
      get () {
        return this.formValues.inpDeviceSerial
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeviceSerial',
          value: value
        })
      }
    },

    // disabled
    disableConfirmButton () {
      return this.inpDeviceSerial === null
    },

    deliveryPattern() {
      return this.values.inpDeliveryPattern
        .reduce((sum, element) => sum + element)
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      hide: 'noticeTestDeliveryModal/hide',
    }),
    ...mapMutations({
      setInputValue: 'noticeTestDeliveryModal/setInputValue',
    }),

    init () {

    },

    confirmData () {
      this.showConfirm({
        key: 'submit',
        title: '',
        body: 'テスト配信しますか？',
        acceptLabel: '配信'
      })
    },
    postData () {
      this.processing = true

      //jsonbの整形 : アンケートの場合
      let jsonb = {};
      if (this.values.inpDeliveryContents.question) {
        const obj = Object.keys(this.values.inpDeliveryContents)
          .filter(key => key.indexOf('answerOptions') !== -1)
          .map((key, index) => {
            return {
              optionNo: index + 1,
              answer: this.values.inpDeliveryContents[key],
            }
          })
          .filter(item => item.answer !== null)
        jsonb = {
          question: this.values.inpDeliveryContents.question,
          answerOptions: obj
        }
        if (this.values.inpDeliveryContents.soundFile) {
          jsonb.soundFile = $.extend(true, {}, this.values.inpDeliveryContents.soundFile)
        }
      //jsonbの整形 : そのほか
      } else {
        jsonb = $.extend(true, {}, this.values.inpDeliveryContents)
      }

      let parameters = {
        testDeliveryToDeviceSerial: this.inpDeviceSerial,
        request: {
          serviceUuid: this.values.inpService,
          deliveryTypeMstUuid: this.values.inpDeliveryType,
          noticeTypeMstUuid: this.values.inpNoticeType,
          deliveryToKbn: this.values.inpTarget,
          deliveryContents: jsonb,
          // deliveryContents: this.values.inpDeliveryContents,
          noticeSenderName: this.values.inpAuthor,
          deliveryPlanKbn: this.values.inpDeliveryPlanType,
        }
      }
      console.log('register data', parameters)

      // 配信先区分 : 属性配信
      if (this.values.inpTarget === 1) {
        parameters.request.deliveryToAttributeGroupUuids = this.values.inpAttribute
      }
      // 配信先区分 : 個別配信
      if (this.values.inpTarget === 2) {
        parameters.request.deliveryToDeviceSerial = this.values.inpDeviceSerial
      }

      // 配信種別 : 即時配信
      if (this.values.inpDeliveryPlanType === 1) {
        if (this.values.inpImmediateDeliveryEndDate &&
          this.values.inpImmediateDeliveryEndHours &&
          this.values.inpImmediateDeliveryEndMinutes) {
          parameters.request.immediateDelivery = {
            deliveryEndDt: this.getValue('inpImmediateDeliveryEndDate').split('/').join('-') + ' ' + this.values.inpImmediateDeliveryEndHours + ':' + this.values.inpImmediateDeliveryEndMinutes
          }
        }
        // } else if (this.values.inpImmediateDeliveryEndDate) {
        //   parameters.request.immediateDelivery = {
        //     deliveryEndDt: this.getValue('inpImmediateDeliveryEndDate').split('/').join('-') + ' 23:59'
        //   }
        // }
      }
      // 配信種別 : 予約配信
      if (this.values.inpDeliveryPlanType === 2) {
        parameters.request.reservedDelivery = {
          deliveryStartDt: this.getValue('inpReservedDeliveryStartDate').split('/').join('-') + ' ' + this.values.inpReservedDeliveryStartHours + ':' + this.values.inpReservedDeliveryStartMinutes
        }
        if (this.values.inpReservedDeliveryEndDate &&
          this.values.inpReservedDeliveryEndHours &&
          this.values.inpReservedDeliveryEndMinutes) {
          parameters.request.reservedDelivery.deliveryEndDt = this.getValue('inpReservedDeliveryEndDate').split('/').join('-') + ' ' + this.values.inpReservedDeliveryEndHours + ':' + this.values.inpReservedDeliveryEndMinutes
        }
      }
      // 配信種別 : 繰り返し配信
      if (this.values.inpDeliveryPlanType === 3) {
        parameters.request.repeatedDelivery = {
          deliveryPattern: this.deliveryPattern,
          // deliveryPattern: Utility.intByBitArray(this.values.inpDeliveryPattern),
          deliveryStartDt:this.getValue('inpRepeatedDeliveryStartDate').split('/').join('-') + ' ' + this.values.inpRepeatedDeliveryStartHours + ':' + this.values.inpRepeatedDeliveryStartMinutes,
          deliveryEndDt: this.getValue('inpRepeatedDeliveryEndDate').split('/').join('-') + ' 23:59'
        }
      }

      // attachment/soundFileをS3にアップロード
      const attachments = this.values.inpDeliveryContents &&
        this.values.inpDeliveryContents.attachments
        ? this.values.inpDeliveryContents.attachments
        : []
      const soundFile = this.values.inpDeliveryContents &&
        this.values.inpDeliveryContents.soundFile
        ? [this.values.inpDeliveryContents.soundFile]
        : []
      console.log('soundFile', this.values.inpDeliveryContents.soundFile)
      this.postFiles(attachments)
        .then(res => {
          console.log('upload attachments: ', res)
          if (res === 'none') {
              return this.postFiles(soundFile)

          } else {
            let status = Utility.parseResponse(res)

            if (status.result) {
              let list = []
              res.forEach(item => list.push({
                fileName: item.data.fileName,
                contentType: item.data.contentType,
                fileUri: item.data.fileUri,
                fileSize: item.data.fileSize,
                thumbnailUri: item.data.thumbnailUri,
              }))
              parameters.request.deliveryContents.attachments = list

              return this.postFiles(soundFile)
            } else if (status.error) {
              // エラーメッセージ表示
              this.showError(res)
            } else {
              // アプリケーションエラー表示
              this.showError(null)
            }
          }
        })
        .then(res => {
          console.log('upload sound: ', res)
          if (res !== 'none' && res) {
            parameters.request.deliveryContents.soundFile = {
              fileName: res[0].data.fileName,
              contentType: res[0].data.contentType,
              fileUri: res[0].data.fileUri,
              fileSize: res[0].data.fileSize,
              thumbnailUri: res[0].data.thumbnailUri,
            }
          }

          console.log('register data', parameters.request)

          return ApiManager.request(
            ['notice'],
            ['v1NoticeTestDelivery'],
            [parameters])
            .then(res => {
              this.processing = false
              let status = Utility.parseResponse(res)

              if (status.result) {
                this.showToast({
                  title: '',
                  body: 'テスト配信しました。'
                })

                this.closeModal()

              } else if (status.error) {
                // エラーメッセージ表示
                this.showError(res)
              } else {
                // アプリケーションエラー表示
                this.showError(null)
              }
              
            })
            // eslint-disable-next-line
            .catch(error => {
              this.processing = false
              this.showError(null)
            })
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(error)
        })
    },

    postFiles(fileList) {
      return new Promise((resolve, reject) => {
        (async () => {
          if (fileList === undefined || !fileList.length) resolve('none')

          const types = fileList.map(item => 'file')
          const methods = fileList.map(item => 'v1FileS3Post')
          const parameters = []
          for (const file of fileList) {
            const compressedImage = await ImageResize.getCompressedImage(file)
            parameters.push({
              attachment: compressedImage
            })
          }

          let resultList = []
          for (let i = 0; i < fileList.length; i++) {
            await ApiManager.request(
              [types[i]],
              [methods[i]],
              [parameters[i]])
              .then(res => {
                let status = Utility.parseResponse(res)
                if (status.result) {
                  resultList.push(res[0])
                } else if (status.error) {
                  reject(res)
                } else {
                  reject(null)
                }
              })
              // eslint-disable-next-line
              .catch(error => {
                reject(null)
              })
          }
          resolve(resultList)
        })()
      })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}